import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { inject, observer } from 'mobx-react'
import { Progress, Container } from 'semantic-ui-react'
import Loader from '@ui/Loader'
import LanguageSelector from '@ui/LanguageSelector'
import OrganizationLogo from '@ui/OrganizationLogo'

@inject('surveyState')
@observer
class Topnav extends Component {
  render() {
    const { surveyState, hideProgress = false } = this.props
    const { progress, storingPartial } = surveyState

    return (
      <Container className='flex topnav'>
        <div
          className='flex'
          style={{
            margin: '20px 0'
          }}
        >
          <OrganizationLogo />
          <div className='flex'>
            {storingPartial && <Loader inline size='tiny' className='storing' />}
            <LanguageSelector />
          </div>
        </div>
        {!hideProgress && (
          <Progress
            progress
            percent={progress}
            className={surveyState.isLastQuestion ? 'custom' : ''}
          />
        )}
      </Container>
    )
  }
}

export default withTranslation()(Topnav)
